import type { Space } from "../../../util/Types/Sidebar";
import type { Flows, Folder } from "../../../util/Types/Folder";

export interface FlowModalTarget {
  id: string;
  name: string;
  isForm?: boolean;
  type?: string;
  spaceId?: string;
  space?: string | { id: string; name: string };
}

export interface ResolvedFlowFolder {
  folderId: string;
  spaceId?: string;
}

const findFlowInFolderTree = (
  folderList: Folder[],
  flowId: string,
  spaceId?: string,
): ResolvedFlowFolder | null => {
  for (const folder of folderList) {
    if (folder.flows?.some((fl) => fl.id === flowId)) {
      return { folderId: folder.id, spaceId };
    }
    if (folder.folders?.length) {
      const nested = findFlowInFolderTree(folder.folders, flowId, spaceId);
      if (nested) return nested;
    }
  }
  return null;
};

export const resolveFlowFolderLocation = (
  flow: FlowModalTarget,
  privateFolders: Folder[],
  spaces: Space[],
): ResolvedFlowFolder => {
  const fromPrivate = findFlowInFolderTree(privateFolders, flow.id);
  if (fromPrivate) return fromPrivate;
  for (const space of spaces) {
    if (space.flows?.some((fl) => fl.id === flow.id)) {
      return { folderId: "", spaceId: space.id };
    }
    const fromSpace = findFlowInFolderTree(space.folder || [], flow.id, space.id);
    if (fromSpace) return fromSpace;
  }
  const sid =
    flow.spaceId || (typeof flow.space === "string" ? flow.space : flow.space?.id);
  return { folderId: "", spaceId: sid };
};

export const flowTypeForModal = (
  flow: FlowModalTarget,
): "flow" | "chat" | "form" => {
  if (flow.isForm === true) return "form";
  if (flow.type === "chat") return "chat";
  return "flow";
};
